import { LoadingDirectiveModule } from '@shared/loading-directive/loading-directive.module';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IncidenceRateComponent} from '@app/components/publications/incidence-rate/incidence-rate.component';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [
    IncidenceRateComponent,
  ],
  exports: [
    IncidenceRateComponent
  ],
    imports: [
        CommonModule,
        TranslateModule
    ]
})
export class IncidenceRateModule {
}
